import { render, staticRenderFns } from "./VideosGloboplayWrapper.vue?vue&type=template&id=05557dc4&scoped=true&"
import script from "./VideosGloboplayWrapper.vue?vue&type=script&lang=js&"
export * from "./VideosGloboplayWrapper.vue?vue&type=script&lang=js&"
import style0 from "./VideosGloboplayWrapper.vue?vue&type=style&index=0&id=05557dc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05557dc4",
  null
  
)

export default component.exports